export const mandates = [
  {
    id: 1,
    platform: 'AWS',
    creationDate: '2021-06-01T08:28:09.938Z'
  },
  {
    id: 2,
    platform: 'EATTESTATIONS',
    creationDate: '2021-05-30T08:28:09.938Z'
  },
  {
    id: 3,
    platform: 'MYPROCUREMENT',
    creationDate: '2021-05-22T08:28:09.938Z'
  },
  {
    id: 4,
    platform: 'PROVIGIS',
    creationDate: '2021-05-31T08:28:09.938Z',
    comment: 'Ceci est un commentaire relativement long visant à déterminer la capacité d\'affichage de la tooltip sur la liste des mandats de collecte dans l\'écran d\'organisation du back-office de la plateforme'
  }
];

export const mandateDetails = {
  id: 1315,
  platform: 'PROVIGIS',
  creationDate: '2021-06-14T12:39:55.380647Z',
  scope: 'GROUP',
  comment: 'PLATINT-5562',
  fieldsValues: {
    GROUP_NUMBER: '70204275500125',
    PASSWORD: 'cbp5wt3F40987H5LqBxI2w==',
    LOGIN: '1123456'
  }
};

export const mandateFields = {
  PROVIGIS: {
    scope: 'GROUP',
    fields: [
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'LOGIN'
        },
        required: true
      },
      {
        field: {
          secured: true,
          type: 'TEXT',
          key: 'PASSWORD'
        },
        required: true
      },
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'GROUP_NUMBER'
        },
        required: true
      }
    ]
  },
  EATTESTATIONS: {
    scope: 'GROUP',
    fields: [
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'LOGIN'
        },
        required: true
      },
      {
        field: {
          secured: true,
          type: 'TEXT',
          key: 'PASSWORD'
        },
        required: true
      },
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'GROUP_NUMBER'
        },
        required: true
      }
    ]
  },
  AWS: {
    scope: 'GROUP',
    fields: [
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'LOGIN'
        },
        required: true
      },
      {
        field: {
          secured: true,
          type: 'TEXT',
          key: 'PASSWORD'
        },
        required: true
      },
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'GROUP_NUMBER'
        },
        required: true
      }
    ]
  },
  MYPROCUREMENT: {
    scope: 'GROUP',
    fields: [
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'LOGIN'
        },
        required: true
      },
      {
        field: {
          secured: true,
          type: 'TEXT',
          key: 'PASSWORD'
        },
        required: true
      },
      {
        field: {
          secured: false,
          type: 'TEXT',
          key: 'GROUP_NUMBER'
        },
        required: true
      }
    ]
  }
};
